module.exports = __webpack_public_path__ + "media/images/defaultuser-d74a5bcbc7b3b5164beb10003439bf63.jpg";